<!--
  This example requires some changes to your config:

  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/aspect-ratio'),
    ],
  }
  ```
-->
<template>
  <TransitionRoot as="template" :show="open">
    <Dialog as="div" class="relative z-50" @close="closeClicked">
      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed inset-0 hidden  bg-opacity-75 transition-opacity md:block" />
      </TransitionChild>

      <div class="fixed inset-0 z-50 w-screen overflow-y-auto">
        <div class="flex min-h-[90vh] items-stretch justify-center text-center md:items-center md:px-2 lg:px-4">
          <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 md:translate-y-0 md:scale-95" enter-to="opacity-100 translate-y-0 md:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 md:scale-100" leave-to="opacity-0 translate-y-4 md:translate-y-0 md:scale-95">
            <DialogPanel class="flex w-full z-40 transform text-left rounded-xl text-base transition my-1 mx-1 max-w-2xl " >
              <div class="relative flex flex-col w-full m-1 items-center rounded-lg overflow-hidden px-4 pb-8 pt-14 shadow-xl sm:px-6 sm:pt-8 md:p-6 lg:p-8 bg-white/40 backdrop-blur-md ">
                <div>Credits</div>
                <button type="button" class="absolute right-4 top-4 text-gray-500 hover:text-white sm:right-6 sm:top-8 md:right-6 md:top-6 lg:right-8 lg:top-8" @click="closeClicked">
                  <span class="sr-only">Close</span>
                  <XMarkIcon class="h-6 w-6" aria-hidden="true" />
                </button>
                <div class="w-full grid gap-6 mt-6 max-w-2xl"
                  :class="pexels.length < 3 ? 'grid-cols-1 sm:grid-cols-2' : 'grid-cols-1 sm:grid-cols-2'"
                >
                  <div class="bg-white shadow-md rounded-md p-2" v-for="pex in pexels" :key="pex">
                    <div class="rounded-lg p-4 items-center justify-center flex  text-white">
                      <div v-if="pex.photographer">
                        <img
                            :src="resolveMediaUrl(pex.src.medium)"
                            class="object-cover h-48"
                            :alt="alt"
                        />
                        <div class="w-full h-2"></div>
                        <div class="text-xs text-gray-700/40"><a target="_blank" rel="noopener noreferrer" :href="pex?.photographer_url" class="hover:text-indigo-600 hover:font-semibold hover:underline">Photo by {{pex?.photographer}}</a></div>
                      </div>
                      <div v-else>
                        <div class="relative w-full h-full overflow-hidden">
                          <img
                              :src="resolveMediaUrl(pex.image)"
                              class="object-cover h-48"
                              :alt="alt"
                          />
                        </div>
                        <div class="w-full h-2"></div>
                        <div class="text-xs text-gray-700/40"><a target="_blank" rel="noopener noreferrer" :href="pex?.user?.url" class="hover:text-indigo-600 hover:font-semibold hover:underline">Video by {{pex?.user?.name}}</a></div>
                      </div>
<!--                      <img :src="resolveMediaUrl(props.imageUrl)" :alt="props.name" class="rounded max-h-[80vh] object-scale-down m-4 aspect-h-1" />-->
                    </div>
                  </div>
                </div>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script setup>
import {ref, defineExpose, defineProps, computed} from 'vue'
import {
  Dialog,
  DialogPanel,

  TransitionChild,
  TransitionRoot,
} from '@headlessui/vue'
import { XMarkIcon } from '@heroicons/vue/24/outline'
import {resolveMediaUrl} from "@/composables/images.js";


const props = defineProps({
  pexels: Array,
})

const emit = defineEmits(["closed"]);

const openBox = () => {
  open.value = true
}

const closeBox = () => {
  open.value = false
}

const closeClicked = () => {
  emit('closed')
  closeBox()
}

defineExpose({ openBox, closeBox })


const frostedStyle = computed(() => {
  if (props.frosted) {
    return {
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      backdropFilter: 'blur(20px)',
      color: 'white'
    };
  }
  return {
    backgroundColor: 'black',
  };
});


const open = ref(false)
</script>